/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { projectsCreate } from "../funcs/projectsCreate.js";
import { projectsDeleteById } from "../funcs/projectsDeleteById.js";
import { projectsList } from "../funcs/projectsList.js";
import { projectsListAllowedOrigins } from "../funcs/projectsListAllowedOrigins.js";
import { projectsRead } from "../funcs/projectsRead.js";
import { projectsSetLogo } from "../funcs/projectsSetLogo.js";
import { projectsSetOrganizationWhitelist } from "../funcs/projectsSetOrganizationWhitelist.js";
import { projectsUpdate } from "../funcs/projectsUpdate.js";
import { projectsUpsertAllowedOrigin } from "../funcs/projectsUpsertAllowedOrigin.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { CreateProjectResult } from "../models/components/createprojectresult.js";
import { GetProjectResult } from "../models/components/getprojectresult.js";
import { ListAllowedOriginsResult } from "../models/components/listallowedoriginsresult.js";
import { ListProjectsResult } from "../models/components/listprojectsresult.js";
import { SetProjectLogoResult } from "../models/components/setprojectlogoresult.js";
import { UpdateProjectResult } from "../models/components/updateprojectresult.js";
import { UpsertAllowedOriginResult } from "../models/components/upsertallowedoriginresult.js";
import {
  CreateProjectRequest,
  CreateProjectSecurity,
} from "../models/operations/createproject.js";
import {
  DeleteProjectRequest,
  DeleteProjectSecurity,
} from "../models/operations/deleteproject.js";
import {
  GetProjectRequest,
  GetProjectSecurity,
} from "../models/operations/getproject.js";
import {
  ListAllowedOriginsRequest,
  ListAllowedOriginsSecurity,
} from "../models/operations/listallowedorigins.js";
import {
  ListProjectsRequest,
  ListProjectsSecurity,
} from "../models/operations/listprojects.js";
import {
  SetOrganizationWhitelistRequest,
  SetOrganizationWhitelistSecurity,
} from "../models/operations/setorganizationwhitelist.js";
import {
  SetProjectLogoRequest,
  SetProjectLogoSecurity,
} from "../models/operations/setprojectlogo.js";
import {
  UpdateProjectRequest,
  UpdateProjectSecurity,
} from "../models/operations/updateproject.js";
import {
  UpsertAllowedOriginRequest,
  UpsertAllowedOriginSecurity,
} from "../models/operations/upsertallowedorigin.js";
import { unwrapAsync } from "../types/fp.js";

export class Projects extends ClientSDK {
  /**
   * createProject projects
   *
   * @remarks
   * Create a new project.
   */
  async create(
    request: CreateProjectRequest,
    security?: CreateProjectSecurity | undefined,
    options?: RequestOptions,
  ): Promise<CreateProjectResult> {
    return unwrapAsync(projectsCreate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteProject projects
   *
   * @remarks
   * Delete a project by its ID
   */
  async deleteById(
    request: DeleteProjectRequest,
    security?: DeleteProjectSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(projectsDeleteById(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getProject projects
   *
   * @remarks
   * Get project details by slug.
   */
  async read(
    request: GetProjectRequest,
    security?: GetProjectSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetProjectResult> {
    return unwrapAsync(projectsRead(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listProjects projects
   *
   * @remarks
   * List all projects for an organization.
   */
  async list(
    request: ListProjectsRequest,
    security?: ListProjectsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListProjectsResult> {
    return unwrapAsync(projectsList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listAllowedOrigins projects
   *
   * @remarks
   * List allowed origins for a project.
   */
  async listAllowedOrigins(
    request?: ListAllowedOriginsRequest | undefined,
    security?: ListAllowedOriginsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListAllowedOriginsResult> {
    return unwrapAsync(projectsListAllowedOrigins(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * setLogo projects
   *
   * @remarks
   * Uploads a logo for a project.
   */
  async setLogo(
    request: SetProjectLogoRequest,
    security?: SetProjectLogoSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SetProjectLogoResult> {
    return unwrapAsync(projectsSetLogo(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * setOrganizationWhitelist projects
   *
   * @remarks
   * Set organization whitelist status (admin only - requires speakeasy-team API key)
   */
  async setOrganizationWhitelist(
    request: SetOrganizationWhitelistRequest,
    security?: SetOrganizationWhitelistSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(projectsSetOrganizationWhitelist(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateProject projects
   *
   * @remarks
   * Update the display name of the current project.
   */
  async update(
    request: UpdateProjectRequest,
    security?: UpdateProjectSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UpdateProjectResult> {
    return unwrapAsync(projectsUpdate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * upsertAllowedOrigin projects
   *
   * @remarks
   * Upsert an allowed origin for a project.
   */
  async upsertAllowedOrigin(
    request: UpsertAllowedOriginRequest,
    security?: UpsertAllowedOriginSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UpsertAllowedOriginResult> {
    return unwrapAsync(projectsUpsertAllowedOrigin(
      this,
      request,
      security,
      options,
    ));
  }
}
